export default "__VITE_ASSET__DpV8zbK7__"